import { getStorage } from '@/shared/lib'

import type { History } from './history'

export const DEFAULT_HISTORY: History[] = []

export const getSearchHistory = () => {
  const history = getStorage('search-history')

  if (!history) {
    return DEFAULT_HISTORY
  }

  return JSON.parse(history) as History[]
}
